export default __webpack_public_path__ + "media/images/features/yado/twitter-b52d314bbef562d26325817d16ad8b67.png";